<template>
    <div
        ref="sentinel"
        class="sentinel"
        aria-hidden="true"
    />
</template>

<script setup lang="ts">
import { watchEffect, onUnmounted, useTemplateRef } from 'vue';

type Emits = {
    (e: 'visible'): void
};

const emit = defineEmits<Emits>();

const sentinel = useTemplateRef<HTMLElement>('sentinel');
let io: IntersectionObserver | null = null;

const props = withDefaults(defineProps<{
    disabled?: boolean;
    root?: HTMLElement|null;
    offset?: string;
}>(), {
    disabled: false,
    offset: '0px',
    root: null,
});

watchEffect((onCleanup) => {
    if (!sentinel.value || props.disabled || !props.root) {
        return;
    }

    io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
            emit('visible');
        }
    }, {
        rootMargin: `0px 0px ${props.offset} 0px`,
        threshold: 0,
        root: props.root,
    });

    io.observe(sentinel.value);

    onCleanup(() => {
        io?.disconnect();
        io = null;
    });
});

onUnmounted(() => {
    io?.disconnect();
});
</script>


<style>

.sentinel {
    width: 100%;
    height: 1px;

    background-color: transparent;
}

</style>